import { render, staticRenderFns } from "./infoopen.vue?vue&type=template&id=0276e2f1"
import script from "./infoopen.vue?vue&type=script&lang=js"
export * from "./infoopen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports